export default "__VITE_ASSET__C_4JsY33__"